export default __webpack_public_path__ + "static/media/animated-gif-challenge.59327421.png";